import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const FloppyIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="floppy" ref={ref} {...props}>
      <path d="M20.38,5.42,18.65,3.66a3.52,3.52,0,0,0-2.49-1h-11a2.53,2.53,0,0,0-1.78.71,2.56,2.56,0,0,0-.76,1.76V18.87a2.53,2.53,0,0,0,2.51,2.51H18.87a2.53,2.53,0,0,0,2.51-2.51v-11A3.51,3.51,0,0,0,20.38,5.42ZM7.47,4.12h8.18V7a1,1,0,0,1-1,1H8.48a1,1,0,0,1-1-1ZM19.88,18.87a1,1,0,0,1-1,1H5.13a1,1,0,0,1-1-1V5.13a1,1,0,0,1,1-1H6V7A2.51,2.51,0,0,0,8.48,9.49h6.16a2.55,2.55,0,0,0,1.77-.73A2.58,2.58,0,0,0,17.15,7V4.4a2.24,2.24,0,0,1,.43.31L19.3,6.48a2,2,0,0,1,.58,1.4ZM12.1,11.59a3.25,3.25,0,0,0-1.79.54,3.18,3.18,0,0,0-1.19,1.45,3.23,3.23,0,0,0-.19,1.87A3.27,3.27,0,0,0,11.47,18a3.23,3.23,0,0,0,1.87-.19,3.18,3.18,0,0,0,1.45-1.19,3.25,3.25,0,0,0,.54-1.79,3.24,3.24,0,0,0-3.23-3.23Zm0,5a1.72,1.72,0,0,1-1-.29,1.68,1.68,0,0,1-.64-.78,1.79,1.79,0,0,1-.1-1,1.78,1.78,0,0,1,1.36-1.36,1.79,1.79,0,0,1,1,.1,1.68,1.68,0,0,1,.78.64,1.72,1.72,0,0,1,.29,1,1.72,1.72,0,0,1-1.73,1.69Z" />
    </Icon>
  ),
) as IconWithRender;

FloppyIcon.displayName = 'FloppyIcon';
FloppyIcon.renderIcon = (props) => <FloppyIcon {...props} />;
export default FloppyIcon;
